import {useNavigate} from "react-router-dom"

function GetPremium({className}) {
    const navigate = useNavigate()

    function handlePremiumNavigation() {
        navigate('/checkout')
        window.scrollTo(0, 0)
    }

    return (
        <div className={className}>
            <p>Unlock Premium Tools & Features</p>
            {className === "hitterPageGetPremium" && <p>View hitter trends and home/away splits right here</p>}
            <button onClick={handlePremiumNavigation}>View Plans</button>
        </div>
    )
}

export default GetPremium